import BaseComponent from 'foundation/base-component';
import { getAllMainRightLinkItems, getSiblingMemberRightLinkItem, toggleRightHeaderLink } from '../../right-header-link-item/js/right-header-link-item-helpers';
import { hasValue } from '../../../general/js/general-helpers';
import eventBus from '../../../general/js/event-bus';
import { getIsOneClubMemberFromCookie } from '../../sso/components/utils/user-data-cookie/user-data-cookie-helpers';
import { userDataCookieConstants } from '../../sso/components/utils/user-data-cookie/user-data-cookie-constants';

class RightHeaderLinks extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.handleUserDataCookieChange = this.handleUserDataCookieChange.bind(this);
        this.init();
    }

    init() {
        eventBus.addListener(userDataCookieConstants.USER_DATA_COOKIE_CHANGE_EVENT, this.handleUserDataCookieChange);
    }

    onDestroy() {
        eventBus.removeListener(userDataCookieConstants.USER_DATA_COOKIE_CHANGE_EVENT, this.handleUserDataCookieChange);
    }

    handleUserDataCookieChange = () => {
        const isOneClubMember = getIsOneClubMemberFromCookie();
        const mainRightHeaderLinkItems = getAllMainRightLinkItems(this.element);

        if (!hasValue(mainRightHeaderLinkItems)) {
            return;
        }

        mainRightHeaderLinkItems.forEach((mainLinkItem) => {
            const memberLinkItem = getSiblingMemberRightLinkItem(mainLinkItem);
            toggleRightHeaderLink(isOneClubMember, mainLinkItem, memberLinkItem);
        });
    }
}

export default RightHeaderLinks;
